// extracted by mini-css-extract-plugin
module.exports = {"suggestions":"suggestions__1BmbK","suggestion":"suggestion__2yrJc","card":"card__2fs_L","title":"title__OdAHs","orgnr":"orgnr__2K3eU","info":"info__2qyl7"};